import { render, staticRenderFns } from "./IconImage.vue?vue&type=template&id=41c4f885&"
import script from "./IconImage.vue?vue&type=script&lang=js&"
export * from "./IconImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41c4f885')) {
      api.createRecord('41c4f885', component.options)
    } else {
      api.reload('41c4f885', component.options)
    }
    module.hot.accept("./IconImage.vue?vue&type=template&id=41c4f885&", function () {
      api.rerender('41c4f885', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconImage.vue"
export default component.exports